(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sliderElement = document.querySelector('.my-slider')
  if (!sliderElement) return

  // スライド要素の取得
  const slideElements = sliderElement.querySelectorAll('.my-slider__slide')
  let currentSlideIndex = 0
  // data-slide-interval 属性から切替間隔を取得（未指定の場合は 5000ms）
  const slideIntervalDuration =
    parseInt(sliderElement.dataset.slideInterval, 10) || 5000

  /**
  * 全スライドのプログレスバーをリセットする
  */
  const resetProgressBars = () => {
    slideElements.forEach((slide) => {
      const progressBar = slide.querySelector('.my-slider__progress-bar')
      if (progressBar) {
        progressBar.classList.remove('my-slider__progress-bar--animate')
        // プログレスバーの幅を初期化
        progressBar.style.width = '0%'
        // 再描画を促すため reflow を発生させる
        void progressBar.offsetWidth
      }
    })
  }

  /**
  * 指定されたスライドのプログレスバーアニメーションを開始する
  *
  * @param {Element} slide - 対象のスライド要素
  */
  const startProgressBar = (slide) => {
    const progressBar = slide.querySelector('.my-slider__progress-bar')
    if (progressBar) {
      // アニメーション時間をスライド間隔に合わせる
      progressBar.style.animationDuration = slideIntervalDuration + 'ms'
      progressBar.classList.add('my-slider__progress-bar--animate')
    }
  }

  /**
  * 指定されたインデックスのスライドを表示し、対応するプログレスバーを開始する
  *
  * @param {number} index - 表示するスライドのインデックス
  */
  const showSlide = (index) => {
    slideElements.forEach((slide, i) => {
      slide.classList.toggle('my-slider__slide--active', i === index)
    })
    resetProgressBars()
    startProgressBar(slideElements[index])
  }

  // 初回表示スライドのプログレスバーを開始
  startProgressBar(slideElements[currentSlideIndex])

  /**
  * 次のスライドに切り替える
  */
  const nextSlide = () => {
    currentSlideIndex = (currentSlideIndex + 1) % slideElements.length
    showSlide(currentSlideIndex)
  }

  // 指定した間隔で次のスライドに切り替え
  setInterval(nextSlide, slideIntervalDuration)
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // タイルのホバー時の処理
  const tiles = document.querySelectorAll('.tile');
  tiles.forEach(tile => {
    tile.addEventListener('mouseenter', () => {
      const overlay = tile.querySelector('.overlay');
      const tileName = tile.querySelector('.tile-name');
      if (overlay) overlay.style.opacity = '1';
      if (tileName) tileName.style.opacity = '1';
    });
    tile.addEventListener('mouseleave', () => {
      const overlay = tile.querySelector('.overlay');
      const tileName = tile.querySelector('.tile-name');
      if (overlay) overlay.style.opacity = '0';
      if (tileName) tileName.style.opacity = '0';
    });
  });

  // 画像スライドショーの処理
  const sliders = document.querySelectorAll('.image-slider');
  sliders.forEach(slider => {
    const images = slider.querySelectorAll('img');
    if (images.length > 1) {
      let current = 0;
      setInterval(() => {
        images[current].classList.remove('active');
        current = (current + 1) % images.length;
        images[current].classList.add('active');
      }, Math.floor(Math.random() * 5000) + 5000); // 3秒〜8秒でランダムに切り替え
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
